export default {
      id: "checkBox-usage",
      viewBox: "0 0 12 9",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#checkBox",
      toString: function () {
        return this.url;
      }
    }